export default "__VITE_ASSET__CmKksB5N__"